import { loginFormConstraints, LoginPageProps } from "./login-page.types";
import { LoginPage as LoginPageUI } from "../../components/general/login";
import React, { useState } from "react";
import { LoginPayload, PostLoginNavigation, RegisterPayload } from "services";
import validate from "validate.js";
import { useRootStore } from "mobx-stores/store-provider";
import { ApiType, settings } from "../../config";
import { useLocation } from "react-router";

const LoginPageComponent = (props: LoginPageProps) => {
  const location = useLocation();
  const postLoginNav = (location.state as PostLoginNavigation) || undefined;

  const {
    userStore: { login, register, socialLogin },
    cartCheckoutStore: { getCartByUserId },
  } = useRootStore();

  const [formState, setFormState] = useState<LoginPayload>({
    emailAddress: "",
    password: "",
    emailAddressTemp: undefined,
    rememberMe: false,
    reCaptchaToken: "",
  });

  const [formStateRegister, setFormStateRegister] = useState<RegisterPayload>({
    firstName: "",
    lastName: "",
    emailAddress: "",
    password: "",
    emailAddressTemp: undefined,
  });

  const isTempUser = JSON.parse(localStorage.getItem("isTempUser"));

  const onLoginClick = async () => {
    let loginCredentials = formState;
    if (isTempUser) {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      loginCredentials.emailAddressTemp = userDetails.emailAddress;
    }
    const userId = await login(loginCredentials, postLoginNav);
    await getCartByUserId(userId)
  };

  const onRegisterClick = () => {
    let registerCredentials = formStateRegister;
    if (isTempUser) {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      registerCredentials.emailAddressTemp = userDetails.emailAddress;
    }
    register(registerCredentials, postLoginNav);
  };

  function handleRemember(rememberMe: boolean): void {
    setFormState({
      ...formState,
      rememberMe,
    });
  }

  function handleReCaptcha(token: string): void {
    setFormState({
      ...formState,
      reCaptchaToken: token,
    });
  }

  const handleGoogleLogin = () => {
    // Store provider for callback
    localStorage.setItem("oauth_provider", "google");

    fetch(`${settings[ApiType.USER]}/auth/google-url`)
      .then((response) => response.json())
      .then((data) => {
        window.location.href = data.url;
      });
  };

  const handleMicrosoftLogin = () => {
    // Store provider for callback
    localStorage.setItem("oauth_provider", "microsoft");

    fetch(`${settings[ApiType.USER]}/auth/microsoft-url`)
      .then((response) => response.json())
      .then((data) => {
        window.location.href = data.url;
      });
  };

  // const handleAppleLogin = () => {
  //   localStorage.setItem('oauth_provider', 'apple');
  //
  //   fetch(`${settings[ApiType.USER]}/auth/apple-url`)
  //     .then(response => response.json())
  //     .then(data => {
  //       window.location.href = data.url;
  //     });
  // };

  // Handle OAuth callback
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.hash.substring(1));
    const idToken = params.get("id_token");

    if (idToken) {
      // Determine provider from URL or localStorage
      const provider = localStorage.getItem("oauth_provider") || "google";

      // Call social login
      socialLogin(provider, idToken, postLoginNav).then((userId: number) => {
        if (userId) {
          getCartByUserId(userId);
        }
        // Clean up
        localStorage.removeItem("oauth_provider");
        // Clear the hash from URL
        window.history.replaceState(null, null, window.location.pathname);
      });
    }
  }, [socialLogin, getCartByUserId, postLoginNav]);

  return (
    <LoginPageUI
      colorPreset="dark"
      loginButtonProps={{
        children: "Log in",
        onClick: onLoginClick,
        disabled: validate(formState, loginFormConstraints),
      }}
      registerButtonProps={{
        children: "Register",
        onClick: onRegisterClick,
      }}
      emailAddressValue={formState.emailAddress}
      onEmailAddressChange={(emailAddress) =>
        setFormState((s) => ({ ...s, emailAddress }))
      }
      passwordValue={formState.password}
      onPasswordChange={(password) => setFormState((s) => ({ ...s, password }))}
      emailAddressRegisterValue={formStateRegister.emailAddress}
      onEmailAddressRegisterChange={(emailAddress) =>
        setFormStateRegister((s) => ({ ...s, emailAddress }))
      }
      passwordRegisterValue={formStateRegister.password}
      onPasswordRegisterChange={(password) =>
        setFormStateRegister((s) => ({ ...s, password }))
      }
      firstNameValue={formStateRegister.firstName}
      onFirstNameChange={(firstName) =>
        setFormStateRegister((s) => ({ ...s, firstName }))
      }
      lastNameValue={formStateRegister.lastName}
      onLastNameChange={(lastName) =>
        setFormStateRegister((s) => ({ ...s, lastName }))
      }
      onRememberChange={handleRemember}
      onReCaptchaChange={handleReCaptcha}
      onGoogleLogin={handleGoogleLogin}
      onMicrosoftLogin={handleMicrosoftLogin}
      // onAppleLogin={handleAppleLogin}
    />
  );
};

const LoginPage = LoginPageComponent;
export { LoginPage };
